import { render, staticRenderFns } from "./SmsCounter.vue?vue&type=template&id=55c245fa&"
import script from "./SmsCounter.vue?vue&type=script&lang=js&"
export * from "./SmsCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports